export const locale = window.locale
export const baseUrlWithLocale = window.baseUrl
// export const isLogin = !!JSON.parse(window.isLogin)
